import React, { useState } from 'react';

const DataTable = ({ data, onEdit, onDelete, onToggleAtivo, loading }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Calculate pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(data.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const styles = {
    data_table_container: {
      overflowX: 'auto',
    },
    data_table: {
      width: '100%',
      borderCollapse: 'collapse',
    },
    data_table_th: {
      backgroundColor: '#f9f9f9',
      padding: '12px',
      textAlign: 'left',
      borderBottom: '2px solid #ddd',
      fontWeight: 'bold',
    },
    data_table_td: {
      padding: '12px',
      borderBottom: '1px solid #eee',
      textAlign: 'left',
    },
    data_table_td_center: {
      padding: '12px',
      borderBottom: '1px solid #eee',
      textAlign: 'center',
    },
    data_table_td_right: {
      padding: '12px',
      borderBottom: '1px solid #eee',
      textAlign: 'right',
    },
    data_table_tr_hover: {
      backgroundColor: '#f5f5f5',
    },
    link_cell: {
      maxWidth: '300px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    loading_message: {
      textAlign: 'center',
      padding: '20px',
      color: '#777',
    },
    no_data_message: {
      textAlign: 'center',
      padding: '20px',
      color: '#777',
    },
    btn_edit: {
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      padding: '5px',
    },
    btn_delete: {
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      padding: '5px',
    },
    edit_icon: {
      color: '#4169e1',
      fontSize: '18px',
    },
    delete_icon: {
      color: '#e14169',
      fontSize: '18px',
    },
    pagination: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: '40px',
      gap: '5px',
    },
    pagination_button: {
      padding: '8px 12px',
      backgroundColor: '#f1f1f1',
      border: '1px solid #ddd',
      borderRadius: '4px',
      cursor: 'pointer',
    },
    pagination_number: {
      width: '30px',
      height: '30px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f1f1f1',
      border: '1px solid #ddd',
      borderRadius: '4px',
      cursor: 'pointer',
    },
    pagination_number_active: {
      backgroundColor: '#4169e1',
      color: 'white',
      borderColor: '#4169e1',
    },
    results_info: {
      marginTop: '20px',
      textAlign: 'left',
      color: '#777',
      fontSize: '14px',
    },
    checkbox: {
      width: '18px',
      height: '18px',
      cursor: 'default',
      accentColor: '#4169e1',
    },
  };

  return (
    <>
      <div className="data-table-container" style={styles.data_table_container}>
        <table className="data-table" style={styles.data_table}>
          <thead>
            <tr>
              <th style={styles.data_table_th}>ID</th>
              <th style={styles.data_table_th}>NOME</th>
              <th style={styles.data_table_th}>LINK</th>
              <th style={{...styles.data_table_th, textAlign: 'center'}}>TAMANHO</th>
              <th style={{...styles.data_table_th, textAlign: 'center'}}>ATIVO</th>
              <th style={{...styles.data_table_th, textAlign: 'center'}}>EDITAR</th>
              <th style={{...styles.data_table_th, textAlign: 'center'}}>EXCLUIR</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="7" className="loading-message" style={styles.loading_message}>Carregando...</td>
              </tr>
            ) : currentItems.length === 0 ? (
              <tr>
                <td colSpan="7" className="no-data-message" style={styles.no_data_message}>Nenhum dado encontrado</td>
              </tr>
            ) : (
              currentItems.map((item) => (
                <tr key={item.id} style={styles.data_table_tr_hover}>
                  <td style={styles.data_table_td}>{item.id}</td>
                  <td style={styles.data_table_td}>{item.nome}</td>
                  <td style={{...styles.data_table_td, ...styles.link_cell}}>{item.link}</td>
                  <td style={{...styles.data_table_td_center}}>{item.tamanho}</td>
                  <td style={{...styles.data_table_td_center}}>
                    <input
                      type="checkbox"
                      checked={item.ativo}
                      onChange={(e) => onToggleAtivo(item.id, e.target.checked)} // <-- aqui
                    />

                  </td>
                  <td style={{...styles.data_table_td_center}}>
                    <button 
                      onClick={() => onEdit(item)} 
                      style={styles.btn_edit}
                    >
                      <i style={styles.edit_icon}>✎</i>
                    </button>
                  </td>
                  <td style={{...styles.data_table_td_center}}>
                    <button 
                      onClick={() => onDelete(item.id)} 
                      style={styles.btn_delete}
                    >
                      <i style={styles.delete_icon}>🗑</i>
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        <div className="pagination" style={styles.pagination}>
          <button 
            className="pagination-button"
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            style={styles.pagination_button}
          >
            Anterior
          </button>
          
          {Array.from({ length: totalPages }, (_, index) => (
            <button
              key={index + 1}
              onClick={() => handlePageChange(index + 1)}
              className={`pagination-number ${currentPage === index + 1 ? 'active' : ''}`}
              style={currentPage === index + 1 ? {...styles.pagination_number, ...styles.pagination_number_active} : styles.pagination_number}
            >
              {index + 1}
            </button>
          ))}
          
          <button 
            className="pagination-button"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            style={styles.pagination_button}
          >
            Próxima
          </button>
        </div>
        <div className="results-info" style={styles.results_info}>
          Mostrando {indexOfFirstItem + 1} a {Math.min(indexOfLastItem, data.length)} de {data.length} resultados
        </div>
      </div>
    </>
  );
};

export default DataTable;